import { Injectable } from '@angular/core';
import { Configuracion } from 'src/app/modules/security/configuracion/shared/configuracion.model';

@Injectable()
export class ConfiguracionInfo {
    private keyConfiguracion: string = "dataConfiguracion";
    private configuracion: Configuracion;

    getConfiguracion(): Configuracion {
        this.configuracion = JSON.parse(localStorage.getItem(this.keyConfiguracion));
        return this.configuracion;
    }

    setConfiguracion(dataConfiguracion: string): void {
        localStorage.setItem(this.keyConfiguracion, dataConfiguracion);
    }

    delConfiguracion(): void {
        localStorage.removeItem(this.keyConfiguracion);
        localStorage.clear();
    }
}
